<template>
    <div class="order-detail-page">
        <van-sticky>
            <van-nav-bar
                :style="{'paddingTop':statusBarHeight,'backgroundColor':'#FFFFFF'}"
                title="确认订单"
                left-arrow
                @click-left="handleBack"
            />
        </van-sticky>
        <div class="address-info-box">
            <i class="icon icon-arrow"></i>
            <van-cell v-if="!Object.keys(addressInfo).length" is-link :to="`/address/list?uuid=${uuid}&num=${skuNum}`" center>
                <template #title>
                    
                    <span class="custom-title"> <i class="icon icon-address" />请选择收货地址</span>
                </template>
            </van-cell>
            <van-cell v-else 
                is-link 
                center 
                :to="`/address/list?uuid=${uuid}&num=${skuNum}`"
                :title="addressInfo.title" :label="addressInfo.label" />
        </div>
        <div class="goods-info-box">
            <goodsCard :priceSolt="true" @onChangeNum="getNum" :card-data="goodsDetail" />
            <div class="goods-info-text">
                <p class="goods-info-item">商品金额 <span>{{goodsDetail.priceType === 0 ?`¥ ${isNaN(totalMoney)? '' : totalMoney}`: '免费'}} </span></p>
                <p class="goods-info-item">运费 <span>{{postMoney? `¥ ${postMoney}`:'包邮'}}</span></p>
            </div>
        </div>
        <div class="handle-panel">
            <div class="btn-box">
                <p class="price-box">金额： <span>¥ {{isNaN(realPay)? '' : realPay}}</span></p>
                <van-button @click="handleCreatOrder" type="primary">去支付</van-button>
            </div>
            <p class="tips" :style="{paddingBottom: bottomSafeHeight}"></p>
            <!-- <i class="icon icon-tips"></i>暂不支持退款 请确定后再下单哦~ -->
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import goodsCard from '../components/card.vue';
import utils from '../../../utils/publicFn';
import { orderTypeList } from '../config/enum';
import { Toast } from 'vant';

export default {
    components: {
        goodsCard,
    },
    computed: {
        ...mapState(["userInfo"]),
        totalMoney() {
            return (this.goodsDetail.salePrice*this.skuNum).toFixed(2)
        },
        realPay() {
            return (Number(this.totalMoney)+Number(this.postMoney)).toFixed(2)
        },
    },
    beforeRouteLeave(to,from, next) {
        localStorage.removeItem(`address_${this.userInfo.id}`)
        next();
    },
    data() {
        return {
            isWechat: this.$publicFn.getUserAgent() === 'wechat',
            statusBarHeight: 0,
            bottomSafeHeight: 0,
            goodsDetail: {
                name: ''
            },
            skuNum: 1,
            isAddress: true,
            addressParams: null,
            addressInfo: {},
            postMoney: 0,
            uuid: this.$route.params.uuid || '',
            isApp: false
        }
    },
    created() {
        this.$WDJSBridge.useGetAppVersion().then(res=>{
            console.log('获取版本号成功', res)
            this.isApp = res?true:false;
        }).catch(err=>{
            console.log('获取版本号失败', err)
        })
        this.setCompatible();
        this.getlocalStorageAddress().then((res)=>{
            this.formatAddress(res)
        },()=>{
            this.getDefaultAddress();
        })
        this.getDetail();
    },
    methods: {
        setCompatible() {
            if(localStorage.getItem('type') == 'iOS') {
                this.statusBarHeight = `${localStorage.getItem("statusBarHeight")|| 0}px`;
                this.bottomSafeHeight = `${localStorage.getItem("bottomSafeHeight")|| 0}px`;
            }
        },
        getDetail() {
            this.$api.entityOrder.getSelectEntityGoods({
                uuid: this.uuid,    
            }
        ).then(res=>{
            // console.log(res);
            if(res.success){
                const {name, goodsId, num, salePrice, pic, postMoney, skuId, skuNameList, goodsKinds, priceType} = res.data;
                const newNum = this.$route.query.num || num;
                this.postMoney = postMoney;
                
                this.goodsDetail = {
                    ...this.goodsDetail,
                    name,
                    goodsId,
                    salePrice,
                    num: newNum,
                    skuId,
                    goodsKinds,
                    priceType,
                    picUrl: pic,
                    sku: (skuNameList || []).join(',')
                };
            }
        })
        },
        formatAddress(res) {
            const {
                receiver, addr, province, city, area, mobile,
                id,
            } = res;
            this.addressParams = res;
            this.$set(this.addressInfo, 'title', `${receiver} ${mobile}`);
            this.$set(this.addressInfo, 'label', `${province}${city}${area}${addr}`);
            this.addrId = id;
        },
        getlocalStorageAddress() {
            return new Promise((reslove,reject)=>{
                const address = localStorage.getItem(`address_${this.userInfo.id}`) || {};
                const localAddress = JSON.parse(address)
                if(Object.keys(localAddress).length) {
                    reslove(localAddress)
                } else {
                    reject(null)
                }
            })
        },
        getDefaultAddress() {
            this.$api.address.getDefaultAddress().then((res)=>{
                if(res.success) {
                    if(res.data) {
                        this.formatAddress(res.data)
                    } else {
                        this.addressInfo = {};
                    }
                } else {
                    this.addressInfo = {}
                }
            },()=>{
                this.addressInfo = {}
            })
            
        },
        getNum(num) {
            this.skuNum = num
        },
        handleCreatOrder() {
            if(!this.addrId) {
                return Toast('请选择地址')
            }
            const {goodsId, goodsKinds,salePrice,skuId} = this.goodsDetail;
            const detailParams = {
                goodsList: [
                    {
                        goodsId,
                        goodsKinds,
                        salePrice,
                        skuId,
                        num: this.skuNum,
                    }
                ]
            }
            const orderSource = orderTypeList[utils.getUserAgent()];
            if(this.lock) {
                return false;
            }
            this.lock = true;
            this.$api.entityOrder.createdOrder({
                ...detailParams,
                addrId: this.addrId,
                orderSource,
                orderType: 1,
                realPay: this.realPay,
                totalMoney: this.realPay,
                shareUserInfo:sessionStorage.getItem('recommendUserUcode')?sessionStorage.getItem('recommendUserUcode'):''
            }).then((res)=>{
                if(res.success) {
                    if(res.data.status == 2) {
                        this.$router.push({
                            path: `/order/detail/${res.data.orderNo}`,
                            query: {
                                goodsId,
                            }
                        })
                        return false;
                    }   
                    // alert(res.data.orderNo)
                    this.$api.home
                      .prePayOrder({
                          // 调用订单号
                          data: {
                              orderId: res.data.id,
                              orderNo: res.data.orderNo,
                              totalMoney: this.realPay,
                              payInfoDesc: "",
                              scene: 4,
                              agentId: localStorage.getItem('detailAgentId') || ''
                          }
                      })
                      .then(async(prePayRes) => {
                            if (prePayRes.message === "success") {
                                let url  = ''
                                let locationHref = window.location.href
                                if (locationHref.includes('testing')) {
                                    url = 'pay.testing3.wdeduc.com'
                                } else if (locationHref.includes('fat')) {
                                    url = 'pay.fat.wdeduc.com'
                                } else if (locationHref.includes('uat')) {
                                    url = 'pay.uat.wdeduc.com'
                                } else  {
                                    url = 'pay.wdeduc.com'
                                }
                                // 跳转支付系统，在返回使用的标记
                                localStorage.setItem('hasJumpCashier', 1)
                                const successBackUrl = encodeURIComponent(window.location.protocol+'//'+window.location.hostname)
                                const backUrl = window.location.origin + `/orderpage?backPath=/personal`
                                const backUrlBtn = window.location.origin + `/personal`
                                const data = {
                                    key: res.data.orderNo,
                                    value: JSON.stringify({
                                        orderNo: res.data.orderNo,
                                        organ: localStorage.getItem("organ"),
                                        token: localStorage.getItem("token"),
                                        actor: localStorage.getItem("actor"),
                                        branch: localStorage.getItem("branch"),
                                        platform: localStorage.getItem("type"),
                                        // backUrl: window.location.origin + `/order/detail/${res.data.orderNo}?goodsId=${goodsId}`,
                                        backUrl,
                                        iOSstatusBarHeight: localStorage.getItem('statusBarHeight'),
                                        iOSbottomSafeHeight: localStorage.getItem('bottomSafeHeight'),
                                        id: res.data.id,
                                        // referId: this.goodsList.referId,
                                        orderType: res.data.orderType,
                                        successBackUrl: successBackUrl,
                                        CSuccessBackUrl: backUrl
                                        // CSuccessBackUrl: window.location.origin + `/payComplete?backUrl=/order/detail/${res.data.orderNo}&goodsId=${goodsId}`
                                    })
                                }

                                let result = await this.$api.orderPage.jumpPaySaveParams(data)
                                // alert(result.code+'----'+this.handelPaylist.orderNo)
                                // if(result.success) {
                                //     window.location.href = `https://${url}/cashier?orderNo=${this.handelPaylist.orderNo}`
                                // }

                                window.location.href =
                                    "https://" +
                                    `${url}` +
                                    "/cashier?orderNo=" +
                                    `${res.data.orderNo}` +
                                    "&organ=" +
                                    localStorage.getItem("organ") +
                                    "&token=" +
                                    localStorage.getItem("token") +
                                    "&actor=" +
                                    localStorage.getItem("actor") +
                                    "&branch=" +
                                    localStorage.getItem("branch") +
                                    "&backUrl=" +
                                    backUrlBtn +
                                    "&id=" +
                                    goodsId + 
                                    "&orderType=" +
                                    `${res.data.orderType}` +
                                    '&successBackUrl=' + successBackUrl +
                                    "&type=" +
                                    'pay3'
                                
                            }
                      },()=>{
                          this.lock = false;
                      });
                } else {
                    this.lock = false;
                }
            },()=>{
                this.lock = false;
            })
           
        },
        handleBack() {
            const { goodsId, goodsKinds} = this.goodsDetail;
            const goodsDetailUrl = goodsKinds == 3 ? `/entityGoodsDetail`: '/goodsDetail';
            if(!goodsId) {
                this.$router.go(-1)
            } else {
                this.$router.replace(`${goodsDetailUrl}?goodsId=${goodsId}&goodsKinds=${goodsKinds}`)
            }
        }
    },
}
</script>
<style lang="less">
    body,html {
        background-color: #F8FAFC;
    }
</style>
<style lang="less" scoped>
.px2rem(@name,@px){
    @{name}: @px / 37.5px * 1rem
}
.order-detail-page{
    ::v-deep {
        .van-cell {
            padding: 0;
            background-color: #fff;
            .van-icon-arrow {
                display: none
            }
        }
        .van-cell__title {
            .px2rem(font-size, 30);
            .px2rem(line-height, 41);
            color: #333;
            font-family: AvenirNext-DemiBold, AvenirNext;
            font-weight: 600;
            margin-right: 30px; 
        }
        .van-cell__label {
            .px2rem(font-size, 26);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: normal;
            color: #999999;
            .px2rem(line-height, 37);
            word-break: break-all;
        }
        .custom-title {
            color: #1F94FF;
            display: flex;
            flex: 1;
            align-items: center;
            font-weight: 400;
            position: relative;
            margin-right: 30px;
            .px2rem(font-size, 30);
            .px2rem(padding-top, 26);
            .px2rem(padding-bottom, 26);
            .icon-address {
                .px2rem(width, 44);
                .px2rem(height, 44);
                display: inline-block;
                background: url(../asset/images/icon_address.png) no-repeat center center /100% 100%;
                .px2rem(margin-righ, 16);
            }
        }
    }
}
 
.address-info-box {
    padding: 32px;
    position: relative;
    margin-bottom: 16px;
    background-color: #fff;
    overflow: hidden;
    .van-icon-arrow {
        display: none;
    }
    .icon-arrow {
        position: absolute;
        z-index: 1;
        .px2rem(right, 32);
        top: 50%;
        transform: translateY(-50%);
        .px2rem(width, 24);
        .px2rem(height, 24);
        background: url(../asset/images/icon_right.png) no-repeat center center /100% 100%;
    }
    &:after {
        content: '';
        position: absolute;
        left: -16px;
        right: -16px;
        bottom: 0;
        height: 6px;
        background: url(../asset/images/line.png) repeat-x center center /100% 6px;
    }
    .name-phone {
        font-family: AvenirNext-DemiBold, AvenirNext;
        font-weight: 500;
        color: #333333;
        line-height: 41px;
        margin-bottom: 13px;
        font-size: 30px;
    }
    .address {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 37px;
        font-size: 26px;
    }
}
.goods-info-box {
    padding: 32px;
    background-color: #fff;
    .goods-info-text {
        border-top: 1px solid #eaeaea;
        padding-top: 32px;
    }
    .goods-info-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 32px;
        height: 40px;
        line-height: 40px;
        font-size: 28px;
        color: #999;
        &:last-of-type {
            margin-bottom: 0;
        }
        span {
            color: #333;
            font-size: 32px;
        }
    }
}
.handle-panel {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 10px 32px;
    background-color: #fff;
    .btn-box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .price-box {
            display: flex;
            align-items: center;
            color: #333;
            font-size: 26px;
            span {
                display: inline-block;
                margin-left: 16px;
                color: #FE5746;
                font-size: 40px;
            }
        }
    }
    .tips {
        display: flex;
        align-items: center;
        color: #999;
        font-size: 24px;
    }
    .icon-tips {
        width: 28px;
        height: 28px;
        display: inline-block;
        margin-right: 8px;
        background: url(../asset/images/icon_tips.png) no-repeat center center /100% 100%;
    }
}
::v-deep {
    .van-button {
        color: #fff;
        border-radius: 22px;
        margin-left: 12px;
        padding: 0 25px;
        height: 40px;
    }
    .van-button--primary {
        border-color: #FE5746 ;
        background-color: #FE5746;
    }
}
</style>